// src/slices/apiSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import adminAxiosInstance from "../../api/adminAxiosInstance";
import { endpoints } from "../../api/endpoints";
import axiosInstance from "../../api/axiosInstance";


// Define an async thunk for API call
export const fetchRecruiterDetails = createAsyncThunk(
  "AdminAuthSlice/getRecruiterDetails",
  async (Data, { rejectWithValue }) => {
    try {
      const response = await adminAxiosInstance.post(endpoints.recruiterDetails, Data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getallcandidates = createAsyncThunk(
  "AdminAuthSlice/getallcandidates",
  async (Data, { rejectWithValue }) => {
    try {
      const response = await adminAxiosInstance.post(endpoints.getallcandidates, Data);
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const changeStatus = createAsyncThunk(
  "AdminAuthSlice/changeStatus",
  async (Data, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(endpoints.updatestatusofcandidateinrecruiter, Data);
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const dltRecruter = createAsyncThunk(
  "AdminAuthSlice/dltRecruter",
  async (Data, { rejectWithValue }) => {
    try{
      const response = await adminAxiosInstance.post(
        endpoints.deleterecruiterandclient,
        Data
      );
      return response.data;
    }catch(error){
      return rejectWithValue(error.response.data);
    }
  }
)



// Create a slice
const RecruiterSlice = createSlice({
  name: "RecuiterDetails",
  initialState: {
    data: null,
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRecruiterDetails.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })

      .addCase(getallcandidates.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(dltRecruter.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(changeStatus.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchRecruiterDetails.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(getallcandidates.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(dltRecruter.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(changeStatus.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(fetchRecruiterDetails.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(getallcandidates.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(dltRecruter.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(changeStatus.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default RecruiterSlice.reducer;
